var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"turn-button",staticStyle:{"font-size":"1.5rem"}},[_c('b-icon',{attrs:{"icon":"toggle-on","variant":"success"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }